/* Seconde chaîne offerte avec le Collier Ocelle — sans condition.
   L'ancien compte à rebours de 30 minutes a été retiré (audit du 10.09 : un
   cadeau conditionné à un délai n'est plus un cadeau). Il reste le choix de la
   longueur, enregistré comme attribut du panier « Chaîne offerte » pour la
   commande. */
(function () {
  var PRODUCT_ID = 11144467284310;
  var LONGUEURS = ['40 cm', '45 cm', '50 cm'];
  var ATTR = 'Chaîne offerte';
  var cart = null;

  var css = document.createElement('style');
  css.textContent =
    '.co-offre{width:100%;border-top:1px solid #E3E3E3;border-bottom:1px solid #E3E3E3;padding:14px 0;margin:0 0 4px;font-family:var(--font-heading--family,Jost),sans-serif}' +
    '.co-offre__title{font-size:.66rem;letter-spacing:.22em;text-transform:uppercase;margin:0}' +
    '.co-offre__text{font-family:var(--font-body--family,Jost),sans-serif;font-size:.8rem;line-height:1.55;color:#1A1A1A;margin:.5rem 0 .7rem}' +
    '.co-offre__row{display:flex;align-items:center;gap:10px}' +
    '.co-offre__label{font-size:.66rem;letter-spacing:.14em;text-transform:uppercase;color:#6E6E6E}' +
    '.co-offre select{flex:1;border:1px solid #E3E3E3;background:#fff;color:#000;padding:8px 10px;font-size:.8rem;border-radius:0}';
  document.head.appendChild(css);

  function ligneCollier() {
    if (!cart) return null;
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].product_id === PRODUCT_ID) return cart.items[i];
    return null;
  }
  function longueurChoisie(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) if (/cha/i.test(opts[i].name)) return opts[i].value;
    var m = (item.variant_title || '').match(/\d\d cm/);
    return m ? m[0] : '45 cm';
  }
  function setAttr(val) {
    var a = {}; a[ATTR] = val;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; }).catch(function () {});
  }
  function panneau(item) {
    var choisie = longueurChoisie(item);
    var autres = LONGUEURS.filter(function (l) { return l !== choisie; });
    var actuelle = (cart.attributes && cart.attributes[ATTR]) || '';
    if (autres.indexOf(actuelle) < 0) { actuelle = autres[0]; setAttr(actuelle); }
    var el = document.createElement('div');
    el.className = 'co-offre';
    el.innerHTML =
      '<p class="co-offre__title">Seconde chaîne offerte</p>' +
      '<p class="co-offre__text">Avec le Collier Ocelle, nous joignons une seconde chaîne maille forçat ovale 1,2 mm en or jaune 9 carats, dans une autre longueur que celle choisie.</p>' +
      '<div class="co-offre__row"><label class="co-offre__label" for="co-offre-sel">Longueur offerte</label>' +
      '<select id="co-offre-sel">' + autres.map(function (l) { return '<option value="' + l + '"' + (l === actuelle ? ' selected' : '') + '>' + l + '</option>'; }).join('') + '</select></div>';
    el.querySelector('select').addEventListener('change', function (e) { setAttr(e.target.value); });
    return el;
  }
  function rendre() {
    var item = ligneCollier();
    var hosts = document.querySelectorAll('.cart-drawer__summary, .cart-summary__inner');
    if (!item) {
      document.querySelectorAll('.co-offre').forEach(function (n) { n.remove(); });
      if (cart && cart.attributes && cart.attributes[ATTR]) setAttr('');
      return;
    }
    hosts.forEach(function (h) {
      if (h.querySelector('.co-offre')) return;
      var totals = h.querySelector('.cart-totals');
      var p = panneau(item);
      totals ? h.insertBefore(p, totals) : h.prepend(p);
    });
  }
  var enCours = null;
  function charger() {
    if (enCours) return enCours;
    enCours = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; enCours = null; rendre(); })
      .catch(function () { enCours = null; });
    return enCours;
  }
  document.addEventListener('cart:update', function () { setTimeout(charger, 150); });
  document.addEventListener('DOMContentLoaded', charger);
  if (document.readyState !== 'loading') charger();
  var attente = null;
  new MutationObserver(function () {
    if (attente) return;
    attente = setTimeout(function () {
      attente = null;
      var hosts = document.querySelectorAll('.cart-drawer__summary, .cart-summary__inner');
      var manque = false;
      hosts.forEach(function (h) { if (!h.querySelector('.co-offre')) manque = true; });
      if (manque) charger();
    }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
